import $ from 'jquery';
import processInclude from './util';
import * as productTileWishlist from './wishlist/productTile';
import * as carouselWishlist from './wishlist/carousel';

import '~base';

$(document).ready(() => {
  processInclude(productTileWishlist);
  processInclude(carouselWishlist);
});
